import * as core from '../../../../../../../core'

import { query } from './subrecipient-risk-score.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subaward-details.widgets.subrecipient-risk-score',
    description: 'Subrecipient Risk Score',
    name: 'Subrecipient Risk Score',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
